import { z } from 'zod';
import { Category1, Category2 } from './taxonomy.js';
import { CursorQuery, Paginated } from './common/pagination.js';
/**
 * Search & filtration (FR-SRCH-01…08). Every search takes both taxonomies as
 * optional filters — the "Cat-1 × Cat-2 everywhere" rule (docs/02 §1.2 #3).
 * Min 2 chars (AC-GL-06).
 */
export const SearchQuery = CursorQuery.extend({
    q: z.string().trim().min(2).max(100),
    category1: Category1.optional(),
    category2: Category2.optional(),
});
/** People search hit — the universal person row (docs/03 §0.3). */
export const PersonHit = z.object({
    userId: z.string(),
    displayName: z.string(),
    /** Profile picture; absent — never null — when the member has none. */
    avatarUrl: z.string().optional(),
    jobTitle: z.string().nullable(),
    company: z.string().nullable(),
    address: z.string().nullable(),
    /** Set when the viewer is known. */
    mutualCount: z.number().int().nonnegative().optional(),
    /** Rounded kilometres for nearby discovery; precise distances stay on the server. */
    distanceKm: z.number().int().positive().optional(),
});
export const NearbyPeopleQuery = CursorQuery.extend({
    radiusKm: z.coerce.number().int().min(1).max(100).default(100),
    latitude: z.coerce.number().min(-90).max(90).optional(),
    longitude: z.coerce.number().min(-180).max(180).optional(),
}).refine((value) => (value.latitude === undefined) === (value.longitude === undefined), {
    message: 'Provide both latitude and longitude',
});
export const NearbyPeoplePage = Paginated(PersonHit).extend({
    /** No coordinates are returned, including in city fallback mode. */
    location: z.string().nullable(),
    mode: z.enum(['distance', 'city', 'missing']),
    radiusKm: z.number().int().min(1).max(100),
});
/** Feed search reuses ContentBase; people search returns PersonHit. */
//# sourceMappingURL=search.js.map